import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { ConfigModule, I18nModule } from "@spartacus/core";
import { OutletPosition, provideOutlet } from "@spartacus/storefront";
import { NoMouseScrollModule } from "../shared/directives/no-mouse-scroll/no-mouse-scroll.module";
import { FluDashboardBannerModule } from "../shared/modules/flu-dashboard-banner/flu-dashboard-banner.module";
import { ResourcesBannerModule } from "../shared/modules/resources-banner/resources-banner.module";
import { BrowseByTopicComponent } from "./browse-by-topic/browse-by-topic.component";
import { ChildrenVaccinesBannerComponent } from "./children-vaccines-banner/children-vaccines-banner.component";
import { CodingEducationComponent } from "./coding-education/coding-education.component";
import { DownloadEmailSnackbarComponent } from "./coding-education/download-email-snackbar/download-email-snackbar.component";
import { ReimbursementSupportComponent } from "./coding-education/reimbursement-support/reimbursement-support.component";
import { CustomPaginationComponent } from "./custom-pagination/custom-pagination.component";
import { DisplayImgComponent } from "./display-img/display-img.component";
import { ImmunizationSchedulesBannerComponent } from "./immunization-schedules-banner/immunization-schedules-banner.component";
import { LandingPageUsefulLinksComponent } from "./landing-page-useful-links/landing-page-useful-links.component";
import { LandingPageComponent } from "./landing-page/landing-page.component";
import { NotificationBarComponent } from "./notification-bar/notification-bar.component";
import { PatientEducationComponent } from "./patient-education/patient-education.component";
import { RequestConfirmationComponent } from "./request-confirmation/request-confirmation.component";
import { ReturnsPageComponent } from "./returns-page/returns-page.component";
import { ReviewRequestComponent } from "./review-request/review-request.component";


@NgModule({
  declarations: [
    PatientEducationComponent,
    BrowseByTopicComponent,
    DisplayImgComponent,
    ReviewRequestComponent,
    NotificationBarComponent,
    RequestConfirmationComponent,
    ReturnsPageComponent,
    LandingPageComponent,
    LandingPageUsefulLinksComponent,
    ChildrenVaccinesBannerComponent,
    ImmunizationSchedulesBannerComponent,
    CodingEducationComponent,
    ReimbursementSupportComponent,
    DownloadEmailSnackbarComponent,
  ],
  imports: [
    CommonModule,
    ResourcesBannerModule,
    FluDashboardBannerModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    ConfigModule,
    I18nModule,
    MatSnackBarModule,
    NgbModule,
    NoMouseScrollModule,
    MatProgressSpinnerModule
  ],
  providers: [
    provideOutlet({
      id: 'patientEducation-Horizontal',
      position: OutletPosition.REPLACE,
      component: PatientEducationComponent,
    }),
    provideOutlet({
      id: 'patientEducation-vertical',
      position: OutletPosition.REPLACE,
      component: BrowseByTopicComponent,
    }),
    provideOutlet({
      id: 'patientEducationPaginationSlot',
      position: OutletPosition.REPLACE,
      component: CustomPaginationComponent,
    }),
    provideOutlet({
      id: 'requestResourceComp',
      position: OutletPosition.REPLACE,
      component: ReviewRequestComponent,
    }),
    provideOutlet({
      id: 'requestconfirmation',
      position: OutletPosition.REPLACE,
      component: RequestConfirmationComponent,
    }),
    provideOutlet({
      id: 'returnsInformationParagraphSlot',  //position
      position: OutletPosition.REPLACE,
      component: ReturnsPageComponent,

    }),
    provideOutlet({
      id: 'immunizationschedules-Rightsection', //position
      position: OutletPosition.REPLACE,
      component: ImmunizationSchedulesBannerComponent,
    }),
    provideOutlet({
      id: 'vaccinesforchildren-Rightsection',
      position: OutletPosition.REPLACE,
      component: ChildrenVaccinesBannerComponent,
    }),





    provideOutlet({
      id: 'BodyContentReimbursement',
      position: OutletPosition.REPLACE,
      component: CodingEducationComponent,
    }),
    provideOutlet({
      id: 'BodyContentReimburseSupport',
      position: OutletPosition.REPLACE,
      component: ReimbursementSupportComponent,
    }),
  ],
})
export class ToolsAndResourcesModule { }
